import $ from "../vendor/jquery-1.11.0.min"

// Unused?
// import '../vendor/aes'

// Importing not working. Will have to remain included in the html
// import '../vendor/royalslider/jquery.royalslider.min';

window.$ = $;
window.jQuery = $;

// FROM main.js

// 04.08.2014
// klaudius.godziek@wordbridge.de
//

$(document).ready(function() {

  // slide teaser
  if($(".royalSlider").length > 0) {
    $(".royalSlider").royalSlider({
      loop: true,
      keyboardNavEnabled: true,
      controlNavigation: 'none',
      autoScaleSliderHeight: 460,
      autoScaleSliderWidth: 1300,
      imgWidth: 1300,
      imgHeigh: 460,
      slidesSpacing: 0,
      transitionType: 'move',
      globalCaption: true,
      imageScaleMode: 'none',
      autoPlay: {
        // autoplay options go gere
        enabled: true,
        pauseOnHover: true,
        delay: 3500
      }
    });
  }

  $("#category-menu-control").on("click", function() {
    $("#category-menu").toggle();
  });

  var d = new Date();
  var n = d.getDate();
  var h = "hid";
  if($(".contact form").length > 0) {
    $(".form-1_submit").append("<input type='" + h + "den' name='yourname' value='" + (n + 1) + "'>");
  }
  if($(".blog-single-page form").length > 0) {
    $(".form-1_submit").append("<input type='" + h + "den' name='sdeos' value='" + (n + 0) + "'>");
  }
}); // document ready

$(document).mouseup(function(e) {
  var container = $("#category-menu");
  if(!container.is(e.target) // if the target of the click isn't the container...
    && container.has(e.target).length === 0) // ... nor a descendant of the container
  {
    container.hide();
  }
});

// FROM head.inc

window.addEventListener("load", function() {
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#efefef",
        "text": "#404040"
      },
      "button": {
        "background": "#00578b",
        "text": "#ffffff"
      }
    },
    "type": "opt-out",
    "content": {
      "message": "Wir verwenden Cookies, um unseren Service und die Nutzung unserer Website zu verbessern.",
      "dismiss": "verstanden",
      "deny": 'ablehnen',
      "allow": "akzeptieren",
      "link": "mehr erfahren",
      "href": "/impressum/",
      "revoke": "cookies deaktivieren",
      "close": '&#x274c;',
    },

    revokable: false,
    onInitialise: function(status) {
      var type = this.options.type;
      var didConsent = this.hasConsented();
      //console.log(this.hasConsented() ? 'enable cookies' : 'disable cookies');
      if(type == 'opt-in' && didConsent) {
        // enable cookies
        gaOptin()
      }
      if(type == 'opt-out' && !didConsent) {
        // disable cookies
        gaOptout();
      }
    },
    onStatusChange: function(status, chosenBefore) {
      var type = this.options.type;
      var didConsent = this.hasConsented();
      if(type == 'opt-in' && didConsent) {
        // enable cookies
        gaOptin()
      }
      if(type == 'opt-out' && !didConsent) {
        // disable cookies
        gaOptout();
      }
    },
    onRevokeChoice: function() {
      var type = this.options.type;

      //console.log(this.hasConsented() ? 'enable cookies' : 'disable cookies');
      if(type == 'opt-in') {
        gaOptout();
      }
      if(type == 'opt-out') {
        // enable cookies
        gaOptin();
      }
    }


  })
});


var gaProperty = 'UA-64543223-1';
var disableStr = 'ga-disable-' + gaProperty;
if(document.cookie.indexOf(disableStr + '=true') > -1) {
  window[disableStr] = true;
}

function gaOptout() {
  document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
  window[disableStr] = true;
  console.log('ga disabled');
}

function gaOptin() {
  document.cookie = disableStr + '=false; expires=Thu, 31 Dec 2000 23:59:59 UTC; path=/';
  window[disableStr] = false;
  console.log('ga enabled');
}

(function(i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function() {
    (i[r].q = i[r].q || []).push(arguments)
  }, i[r].l = 1 * new Date();
  a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m)
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-64543223-1', 'auto');
ga('set', 'anonymizeIp', true);
ga('send', 'pageview');



// WEBPACK FOOTER //
// ./src/assets/js/app.js